module.exports = __webpack_public_path__ + "media/images/kaoawase/top/kaoawase-og-image-00cf080b1c52e4008823d8b696fcd7de.png";